import Api from './Api';

const END_POINT = 'categories'

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(category) {
        return await Api.post(`${END_POINT}`, category)
    },
    async update(category) {
        return await Api.patch(`${END_POINT}/${category.id}`, category)
    },
    async change_status(category) {
        return await Api.patch(`${END_POINT}/${category.id}/change-status`, category)
    },
    async delete(category) {
        return await Api.delete(`${END_POINT}/${category.id}`, category)
    }
}